<template>
  <dialog-template 
    :headerTitle="'选择商品类目'" 
    :visible.sync="dialogVisible"
    :append-to-body="true"
    @close="close"
    :width="'726px'">
    <div>
        <div class="search">
            <el-input
                placeholder="搜索商品类目"
                prefix-icon="el-icon-search"
                @keyup.enter="searchType"
                v-model="typeKeyWord">
                <i v-if="typeKeyWord" @click="typeKeyWord = ''" slot="suffix" class="el-input__icon el-icon-error"></i>
            </el-input>
        </div>
        <div class="types">
            <ul v-if="!noTypes" class="left-list">
                <template v-for="(item, index) in showGoodsTypes" >
                    <li 
                        v-if="getItemNum(item.children)"
                        :class="{'actived': activedNum === index}" 
                        @click="activedNum = index"
                        :key="index">
                        {{item.typeName}}
                    </li>
                </template>
            </ul>
            <div class="item-right"> 
                <template v-for="(item, index) in showGoodsTypes[activedNum].children">
                    <div v-if="item.children && item.children.length" class="type-item" :key="index">
                        <p class="title">{{item.typeName}}</p>
                        <ul class="items">
                            <div
                                v-for="(childItem, childindex) in item.children"
                                :class="oldType === childItem.name ? 'seleted' : ''"
                                @click="choose(childItem)"
                                :key="childindex">
                                <!-- 其他水果/肉类 等 这几个标签不要图片 -->
                                <img v-if="isShowImg(childItem.name)" class="bg" :src="getQiniuImgUrl('cashier_goods_image/' + childItem.img + '.png')"/>
                                <span>{{childItem.name}}</span>
                                <i v-if="oldType === childItem.name" class="iconfont iconyixuan"></i>
                            </div>
                        </ul>
                    </div>
                </template>
            </div>
            <div v-if="noTypes" class="no-types">
                <img src="~@/assets/images/emptyBox.svg" />
                <p>暂无所对应的商品类目</p>
            </div>
        </div>
    </div>
  </dialog-template>
</template>

<script>
import { goodsTypes, filterTypes } from '@/config/allGoodsTypes'
import { getQiniuImgUrl } from '@/assets/ts/qiniu'

export default {
    data() {
        return {
            dialogVisible: false,
            typeKeyWord: '',
            showGoodsTypes: goodsTypes,
            goodsTypes: goodsTypes,
            activedNum: 0,
            getQiniuImgUrl: getQiniuImgUrl,
            noTypes: false
        }
    },

    props: {
        oldType: {
            type: String,
            default: ''
        },

        goodName: {
            type: String,
            default: ''
        }
    },

    watch: {
        typeKeyWord(val) {
            this.searchType(val)
        }
    },

    methods: {
        open(options = {}) {
            this.$set(this.goodsTypes[0].children[0], 'children', filterTypes(this.goodName).simpleTypes)
            this.$set(this.goodsTypes[0].children[1], 'children', this.getRecentlySeleted())
            this.showGoodsTypes = this.goodsTypes
            this.dialogVisible = true
        },

        close() {
            this.typeKeyWord = ''
        },

        isShowImg(name) {
            return name.indexOf('其他') === -1
        },

        choose(childItem) {
            let imgKey = 'cashier_goods_image/' + childItem.img + '.png'
            this.$emit('choose', {
                id: childItem.id,
                name: childItem.name,
                imgKey,
                imgSrc: getQiniuImgUrl(imgKey, 800)
            })
            this.setRecentlySeleted(childItem)
            this.dialogVisible = false
        },

        searchType(val) {
            this.iptLock = true
            if (this.timer) clearInterval(this.timer)
            this.timer = setInterval(() => {
                this.iptLock = false
                if (val.trim()) {
                    let result = filterTypes(val)
                    this.showGoodsTypes = result.newTypes
                    this.activedNum = result.firstSuitType
                    if (result.simpleTypes.length === 0) {
                        this.noTypes = true
                    }
                } else {
                    this.showGoodsTypes = this.goodsTypes
                    this.activedNum = 0
                    this.noTypes = false
                }
                clearInterval(this.timer)
            }, 0.8 * 1000)
        },

        getItemNum(item) {
            let show = false
            for (let i = 0; i < item.length; i++) {
                if (item[i].typeName === '推荐' && !this.typeKeyWord) {
                    show = true
                    break;
                }
                if (item[i].children && item[i].children.length > 0) {
                    show = true
                    break;
                }
            }
            return show
        },

        getRecentlySeleted() {
            let recentlySeleted = localStorage.getItem('GoodsTypsRecentlySeleted')
            if (recentlySeleted) {
                return recentlySeleted.split('|').map(item => JSON.parse(item))
            } else {
                return []
            }
        },
        
        setRecentlySeleted(childItem) {
            let recentlySeleted = localStorage.getItem('GoodsTypsRecentlySeleted')
            if (recentlySeleted) {
                // 如果有了 就不添加了
                recentlySeleted = recentlySeleted.split('|').map(item => JSON.parse(item)).filter(item => item.name !== childItem.name)
                recentlySeleted.unshift(childItem)
                if (recentlySeleted.length > 10) {
                    recentlySeleted.pop()
                }
                localStorage.setItem('GoodsTypsRecentlySeleted', recentlySeleted.map(item => JSON.stringify(item)).join('|'))
            } else {
                localStorage.setItem('GoodsTypsRecentlySeleted', JSON.stringify(childItem))
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding: 0 12px 12px 12px!important;
} 
.search {
    height: 50px;
    padding: 5px 0 0 452px;

    .el-icon-error {
        font-size: 18px;
        color: #999;
    }
}
.types {
    position: relative;
    display: flex;
    height: 444px;
    background: #F2F2F2;
}
.left-list {
    height: 100%;
    background: #FFFFFF;
    border: 1px solid #EBEBEB;
    cursor: pointer;
    > li {
        width: 94px;
        height: 56px;
        font-size: 14px;
        text-align: center;
        line-height: 56px;
        border-bottom: 1px solid #EBEBEB;
    }
    .actived {
        font-weight: bolder;
        color: #009688;
        background: #E5F4F3;
    }
}
.item-right {
    flex: 1;
    height: 100%;
    padding: 12px 12px 0;
    border-radius: 0 4px 4px 0;
    overflow-y: scroll;
    .type-item {
        margin-bottom: 20px;
    }
    .title {
        font-size: 14px;
        color: #333;
        font-weight: bold;
        margin-bottom: 8px;
    }
    .items {
        display: flex;
        flex-wrap: wrap;
        > div {
            position: relative;
            width: calc(20% - 7px);
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            background: #FFFFFF;
            color: #333;
            border-radius: 5px;
            margin: 0 8px 8px 0;
            overflow: hidden;
            cursor: pointer;
            &:nth-of-type(5n) {
                margin-right: 0;
            }
            &:hover {
                line-height: 38px;
                border: 1px solid #009688;
                .bg {
                    top: -4px;
                    right: -14px;
                }
            }
            .bg {
                position: absolute;
                top: -3px;
                right: -13px;
                display: block;
                width: 50px;
                height: 50px;
                opacity: 0.16;
            }
            .iconyixuan {
                position: absolute;
                right: 0;
                top: 12px;
                right: -1px;
                height: 14px;
                color: #009688;
            }
        }
        .seleted {
            font-weight: bold;
            line-height: 38px;
            border: 1px solid #009688;
            &:hover {
                line-height: 38px;
                border: 1px solid #009688;
                .bg {
                    top: -4px;
                    right: -14px;
                }
            }
        }
    }
}
.no-types {
    position: absolute;
    width: 100%;
    height: 100%;

    > img {
        display: block;
        width: 68px;
        margin: 123px auto 12px;
    }

    p {
        text-align: center;
        line-height: 20px;
        font-size: 14px;
        color: #707070;
    }
}
</style>